import { createProfessionalExporter } from '../../../utils/professionalExport';

/**
 * Export/print a finance report for the active tab.
 * @param {{ title: string, headers: string[], rows: string[][], summary?: string[], slug?: string }} report
 */
function createReportExporter(report) {
  return createProfessionalExporter({
    title: report.title || 'Finance Report',
    headers: report.headers || [],
    slug: report.slug || 'finance',
    getRows: (data) => data.rows || [],
    getSummary: (data) => data.summary || [],
  });
}

export function printFinanceList(report) {
  createReportExporter(report).print(report);
}

export function exportFinanceCsv(report) {
  createReportExporter(report).csv(report);
}

export function exportFinanceExcel(report) {
  createReportExporter(report).excel(report);
}

export function exportFinancePdf(report) {
  createReportExporter(report).pdf(report);
}

export function exportFinance(report) {
  createReportExporter(report).export(report);
}
